import { apiClient } from "@/services/HttpService";

export function saveRiskAssess(params) {
  return apiClient.post("/risk/result", params);
}